import { createSlice } from "@reduxjs/toolkit";
const itemsSlice = createSlice({
  name: "items",
  initialState: {
    Items: null,
  },
  reducers: {
    itemsSuccess: (state, action) => {
      state.Items = [...action.payload];
    },
    clearItems: (state) => {
      state.Items = null;
    },
  },
});
export const { itemsSuccess, clearItems } = itemsSlice.actions;
export default itemsSlice.reducer;
